export const tariffBookKeys = {
  all: ['tariff-book'],
  lists: () => ['tariff-book', 'list'],
  list: (params) => ['tariff-book', 'list', params],
  details: () => ['tariff-book', 'detail'],
  detail: (id) => ['tariff-book', 'detail', id],
  items: (id, params) => ['tariff-book', 'items', id, params],
  classes: (id) => ['tariff-book', 'classes', id],
  superAdminItems: (id, params) => [
    'tariff-book',
    'super-admin',
    'items',
    id,
    params,
  ],
  superAdminClasses: (id) => ['tariff-book', 'super-admin', 'classes', id],
};

export const tariffBookStaleTime = {
  LIST: 5 * 60 * 1000,
  DETAIL: 5 * 60 * 1000,
  ITEMS: 5 * 60 * 1000,
  CLASSES: 10 * 60 * 1000,
};
